class RotatingAnnouncementBar extends HTMLElement {
  constructor() {
    super()
    this.RotatingAnnouncementBar = this
    this.interval = this.dataset.interval
    this.arrows = this.dataset.arrows === 'true'
    this.pagination = this.dataset.pagination === 'true'
    this.pause = this.dataset.pause === 'true'
    this.slides = this.querySelectorAll('.splide__slide')
  }

  connectedCallback() {
    const splideOptions = {
      type: 'loop',
      autoplay: true,
      interval: parseInt(this.interval) || 5000,
      arrows: this.arrows,
      perPage: 1,
      pagination: this.pagination,
      pauseOnHover: this.pause,
      pauseOnFocus: this.pause,
    }

    if (this.slides.length >= 2) {
      new Splide(
        this.RotatingAnnouncementBar.querySelector('.splide.announcement-bar'),
        splideOptions
      ).mount()
    }
  }
}

customElements.define('rotating-announcement-bar', RotatingAnnouncementBar)
